import type { MouseEvent, ReactNode } from "react";
import type { VariantProps } from "class-variance-authority";
import { cva, cx } from "class-variance-authority";
import { Slot } from "@radix-ui/react-slot";

import * as styles from "./Clamp.module.scss";

const clampVariants = cva(styles.clamp, {
  variants: {
    variant: {
      success: styles.success,
      danger: styles.danger,
      dangerSoft: styles.dangerSoft,
      warning: styles.warning,
      neutral: styles.neutral,
      grey: styles.grey,
      light: styles.light,
      dark: styles.dark,
      disabled: styles.disabled,
      info: styles.info,
    },
    shape: {
      default: styles.shapeDefault,
      rounded: styles.shapeRound,
    },
  },
  defaultVariants: {
    variant: "neutral",
    shape: "default",
  },
});

type ClampProps = {
  className?: string;
  children?: ReactNode;
  onClick?: (event: MouseEvent) => void;
  asChild?: boolean;
} & VariantProps<typeof clampVariants>;

const Clamp = ({
  children,
  variant,
  shape,
  onClick,
  className,
  asChild = false,
}: ClampProps) => {
  const Component = asChild ? Slot : "div";

  return (
    <Component
      onClick={onClick}
      className={cx(clampVariants({ variant, shape }), className)}
    >
      {children}
    </Component>
  );
};

Clamp.displayName = "Clamp";

export { Clamp, clampVariants };
